import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";
import { TCargoGeral } from "../../../../types";
import api from "../../../../utils/api";
import { UseListMembros } from "../context/ListMembros";

export type TCargoServices = {
  cargos: TCargoGeral[],
  cargoUsuario: any,
  getCargoUser: (event: any) => any,
  updateCargo: VoidFunction,
  alterCargo: (value: any) => any
}

const CargoServices = ({
  reset
}: {
  reset: () => Promise<any>
}|undefined) => {

  const { setErrorSuccess } = useErrorSuccess();

  const [cargo, setCargo] = useState<TCargoGeral>();

  const getCargoUser = (value: any) => setCargo(value);

  const { data: cargos = [] } = useQuery({
    queryKey: ['cargo-geral'],
    queryFn: async () =>
      api.get<TCargoGeral[]>('ministerio/cargo/geral'),
    select: (data) => data?.data
  });

  const updateCargo = async () => {
    try {
      const req = await api.put(`ministerio/cargo/usuario/aprovar/${cargo?.usuario}/${cargo?.celula}`,
        {
        cargo: cargo?.cargo
      }
    );

      const res = req.data

      setErrorSuccess({
        mensagem: 'atualizado!',
        status: 'success'
      })

    } catch (error) {

      setErrorSuccess({
        mensagem: JSON.stringify(error?.response?.data),
        status: 'error'
      });

    } finally {
      await reset?.();
    }
  }

  const alterCargo = (cargo: TCargoGeral) => {
    setCargo((value) => ({
      ...value,
      cargo: cargo?.codigo,
      nomecargo: cargo?.descricao
    }));
  }

  return {
    cargos,
    cargoUsuario: cargo,
    getCargoUser,
    updateCargo,
    alterCargo
  };
}

export default CargoServices;
